exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cap-it-ui-alert-bar .error-alert-bar .alert-bar-base{background-color:rgba(178,0,0,.9)}.cap-it-ui-alert-bar .error-alert-bar h3{font-weight:400;margin-bottom:0;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/alert-bar/styles/error-alert-bar.scss
// module id = 5231
// module chunks = 0